export class MongoAtlasOidc {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpServiceAccountUniqueId",
            "baseName": "gcpServiceAccountUniqueId",
            "type": "string",
            "format": ""
        },
        {
            "name": "azureIssuerUri",
            "baseName": "azureIssuerUri",
            "type": "string",
            "format": ""
        },
        {
            "name": "tokenResource",
            "baseName": "tokenResource",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MongoAtlasOidc.attributeTypeMap;
    }
    constructor() {
    }
}
